import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {MatButtonModule} from '@angular/material/button';
import {MatNativeDateModule} from '@angular/material/core';
import {MatDatepickerModule} from '@angular/material/datepicker';
import {MatDialogModule} from '@angular/material/dialog';
import {MatIconModule} from '@angular/material/icon';
import {MatInputModule} from '@angular/material/input';
import {MatSelectModule} from '@angular/material/select';
import {MatTooltipModule} from '@angular/material/tooltip';
import {NgxMatSelectSearchModule} from 'ngx-mat-select-search';
import {PortalSelectModule} from '../portal-select/portal-select.module';
import {SpinnerButtonModule} from '../spinner-button/spinner-button.module';
import {MultiReassignSpecialistComponent} from "./multi-reassign-specialist.component";
import {ButtonModule} from '@ucx/ui-cmp';
import {TooltipModule} from "../tooltip/tooltip.module";
import {MatCheckboxModule} from "@angular/material/checkbox";
import {MatExpansionModule} from "@angular/material/expansion";




@NgModule({
  declarations: [MultiReassignSpecialistComponent],
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        MatButtonModule,
        MatSelectModule,
        MatDatepickerModule,
        MatNativeDateModule,
        MatTooltipModule,
        MatInputModule,
        NgxMatSelectSearchModule,
        MatDialogModule,
        MatIconModule,
        PortalSelectModule,
        SpinnerButtonModule,
        ButtonModule,
        ButtonModule,
        TooltipModule,
        MatCheckboxModule,
        MatExpansionModule
    ],
  providers: [],
  exports: [
    MultiReassignSpecialistComponent
  ]
})
export class MultiReassignSpecialistModule { }
